import 'stylesheets/widget_builder'

document.addEventListener('turbolinks:load', function () {
  var $ = window.jQuery || window.$;

  if (!$ || !$('#widget-form').length) {
    return;
  }

  if (!new URLSearchParams(window.location.search).has('type')) {
    $('#type').val('portrait');
  }

  $('#widget-form')
    .off('change.widgetBuilder')
    .on('change.widgetBuilder', function () {
      $('#get-preview-button').trigger('click');
    });

  $('#code-creation')
    .off('click.widgetBuilder')
    .on('click.widgetBuilder', function () {
      $('#get-preview-button').trigger('click');
      $('#code-block').removeClass('d-none').addClass('d-block');
    });

  $('#get-widget-code')
    .off('click.widgetBuilder')
    .on('click.widgetBuilder', function () {
      $('textarea')[0].select();
      document.execCommand('copy');
    });

  $('textarea')
    .off('mouseup.widgetBuilder')
    .on('mouseup.widgetBuilder', function () {
      $(this)[0].select();
      document.execCommand('copy');
    });
});
